import { BehaviorParameters } from 'rangeConfig/@types';
import { ProductType } from '@inter-ikea-storageone/range';

const removeShelfOrganizersInScene = ({ coreApi }: BehaviorParameters) => {
  const shelvesAndFrames = coreApi.entities.getByProductTypes([
    ProductType.PLATSA_SHELF,
    ProductType.PLATSA_FRAME,
    ProductType.PLATSA_OPEN_FRAME_SHELVES,
    ProductType.PLATSA_OPEN_FRAME_HANGING,
    ProductType.PLATSA_OPEN_FRAME_SHOES
  ]);
  const shelfOrganizers = shelvesAndFrames.flatMap(entity =>
    coreApi.entities.getChildrenWithOneOfProductTypes(entity, [
      ProductType.PLATSA_SHELF_ORGANIZER,
      ProductType.PLATSA_SHELF_AND_DRAWER_ORGANIZER
    ])
  );
  coreApi.entities.deleteMultiple(shelfOrganizers);
};

export default removeShelfOrganizersInScene;
